import type { StyleSystemProps } from '@withjoy/joykit';
import { Box, TextV2, styled } from '@withjoy/joykit';

export const StyledTitle = styled(TextV2)``;
export const StyledContainer = styled(Box)``;
export const StyledCategoryContainer = styled(Box)``;

const titleStyles: StyleSystemProps = {
  maxWidth: {
    _: '294px',
    sm2: '675px',
  },
  display: 'flex',
  alignSelf: 'center',
  textAlign: 'center',
  margin: '0px 48px 64px 48px',
};

const containerStyles: StyleSystemProps = {
  display: 'flex',
  flexDirection: 'column',
};

const categoryContainerStyles: StyleSystemProps = {
  marginBottom: '98px',
};

export const styles = {
  container: containerStyles,
  title: titleStyles,
  categoryContainer: categoryContainerStyles,
};
